import React from 'react';

export default function LoadingHero() {
  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes loadingHeroPulse {
          0%, 60%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          30% {
            opacity: 1;
            transform: scale(1.3);
          }
        }

        .loading-hero-dot {
          width: 8px;
          height: 8px;
          background: var(--color-accent);
          border-radius: 50%;
          animation: loadingHeroPulse 1.5s ease-in-out infinite;
        }

        .loading-hero-dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .loading-hero-dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @media (prefers-reduced-motion: reduce) {
          .loading-hero-text {
            animation: none !important;
          }
          .loading-hero-dot {
            animation: none !important;
            opacity: 0.6 !important;
          }
        }
      `}</style>

      <div
        data-testid="loading-hero-container"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, var(--color-bg) 0%, var(--color-surface) 50%, var(--color-bg) 100%)',
          zIndex: 0
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px'
          }}
        >
          <div
            className="loading-hero-text"
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: '38px',
              color: 'var(--color-accent)',
              letterSpacing: '0.06em',
              animation: 'fadeInUp 1.2s ease-in-out'
            }}
          >
            Framing stories
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            <div data-testid="loading-dot" className="loading-hero-dot" />
            <div data-testid="loading-dot" className="loading-hero-dot" />
            <div data-testid="loading-dot" className="loading-hero-dot" />
          </div>
        </div>
      </div>
    </>
  );
}
